module.exports = __webpack_public_path__ + "static/img/top.c78d8f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/10/top.jpg
// module id = WVLW
// module chunks = 27